<template>
  <div class="customized">
    <!-- 图片 -->
    <div class="image">
      <img src="/static/image/zixun.png" alt />
    </div>
    <!-- 内容 -->
    <div class="content-table col-7 clearFloat" style="margin-top:1.5%;display:flex;">
      <!-- 左边 -->
      <div class="contentLeft">
        <div class="leftTop clearFloat">
          <i class="contentLeftPic"></i>
          <h3 class="contentLeftTitle">导航条目</h3>
        </div>
        <ul class="leftBottom">
          <li :class="['leftBottomList',{'listActive':listActive === 1}]" @click="notice">
            <i class="el-icon-arrow-right"></i>通知公告
          </li>
          <li :class="['leftBottomList',{'listActive':listActive === 2}]" @click="consultation">
            <i class="el-icon-arrow-right"></i>产品资讯
          </li>

          <li :class="['leftBottomList',{'listActive':listActive === 3}]" @click="down">
            <i class="el-icon-arrow-right"></i>资料下载
          </li>
        </ul>
      </div>
      <!-- 右边 -->
      <div class="contentRight" style="min-height:700px">
        <component
          :is="componented"
          :faNum="faNum"
          :click_detail="click_detail"
          :indexNum="indexNum"
        ></component>
      </div>
    </div>
    <!-- 页脚 -->
    <div class="footerBox">
      <!-- <foot /> -->
    </div>
  </div>
</template>

<script>
import downLoad from "./components/DownLoad.vue";
import mation from "./components/mation/index.vue";
import detail from "./components/mation/detail.vue";
import notice from "./components/notice/index.vue";
import notice_detail from "./components/notice/detail.vue";
import foot from "@/components/footer/index.vue";
export default {
  components: {
    downLoad,
    mation,
    detail,
    notice,
    notice_detail,
    foot
  },
  data() {
    return {
      listActive: 1, //默认为1
      componented: "",
      faNum: 0,
      indexNum: ""
    };
  },
  mounted() {
    this.notice();
    this.view();
  },
  methods: {
    // 通知公告点击事件
    view() {
      if (this.$route.query.status == 1) {
        this.click_detail("notice_detail", this.$route.query.item);
      } else if (this.$route.query.status == 2) {
        this.click_detail("detail", this.$route.query.item);
      } else {
        this.notice();
      }
      if (this.$route.query.page == 1) {
        return;
      } else if (this.$route.query.page == 2) {
        this.consultation();
      }
    },
    notice() {
      this.listActive = 1;
      this.componented = "notice";
    },
    click_detail(num, index) { 
      this.componented = num;
      this.indexNum = index;
    },
    // 产品资讯点击事件
    consultation() {
      this.listActive = 2;
      this.componented = "mation";
    },
    // 资料下载的点击事件
    down() {
      this.listActive = 3;
      this.componented = "downLoad";
    }
  }
};
</script>

<style lang="less" scoped>
li {
  list-style-type: none;
}
.customized {
  width: 100%;
  height: 100%;
  .image {
    width: 100%;
    clear: both;
    img {
      width: 100%;
    }
  }
  .content-table { 
    // 左边
    .contentLeft { 
      width: 18%;
      margin-right: 2%;
      .leftTop {
        padding-bottom: 18px;
        border-bottom: 1px solid #ccc;
        .contentLeftPic {
          float: left;
          width: 8px;
          height: 21px;
          background: url("/static/image/strip.png") no-repeat;
          margin-right: 5%;
          margin-top: -10px;
        }
        .contentLeftTitle {
          // width: 90%;
          line-height: 0;
          color: #c39a58;
        }
      }
      .leftBottom {
        padding-left: 0;
        padding-right: 0;
        .leftBottomList {
          cursor: pointer;
          margin: 3% 0;
          color: #333333;
          .listIcon {
            margin-right: 5%;
          }
        }
        .listActive {
          color: #cca976;
        }
      }
    }
    // 右边
    .contentRight { 
      width: 73%; 
    }
    /deep/.el-tabs__active-bar {
      display: none;
    }
    /deep/.el-tabs__nav-wrap.is-left::after {
      height: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Customized/index.vue